<template>
  <div class="hp-ai">
    <!--main banner-->
    <section class="main-banner-hp">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <div class="mb-content-wrapper">
              <h3>HelpNow Conversational AI</h3>
              <h2>강력하고 유연하며 확장 가능한 <br class="pcblock"/>대화형 AI 플랫폼</h2>
              <p>최신 AI 기술 기반의 챗봇, 음성봇을 기업 시스템과 연계하여<br class="pcblock"/>고객과 직원 모두에게 대화 중심의 자동화 서비스를 제공합니다.</p>
              <a href="https://www.bespinglobal.com/contact/" target="_blank" title="문의하기 이동" class="btn_white">문의하기</a>
            </div>
          </div>
          <div class="col-lg-6 align-self-end">
            <div class="mb-image">
              <img src="@/assets/image/img_helpnow_ai.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <section class="row-hp-pd main-characteristic hp-characteristic mr-b30">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1 class="tit_hp mr-b80">시장을 선도하는 대화형 AI 서비스를 경험하세요</h1>
          </div>
        </div> 
        <!--accordion-->
        <div class="container">
          <div class="row align-items-center">
            <div class="col-md-6 pcblock txt_center">
              <img :src="onCurrAccordionImage" class="img_characteristic"/>
            </div>
            <div class="col-md-6">
              <div class="panel-group accordion" id="myCollapsible" v-for="(item, index) in accordion" :key="index">
                <div class="panel panel-default" @click="onActiveAccordion(item.imageUrl, index)"
                  :class="{
                    'active': onCurrAccordion == index, 
                  }">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                    <a class="first" role="button">
                      {{item.title}} <span></span>
                    </a>
                    </h4>
                  </div>
                  <div class="panel-collapse collapse in">
                    <div class="panel-body">
                      <p>
                        {{item.content}}
                      </p>
                      <div class="mblock wrap_mbolie_c"><img :src="item.imageUrl" class="img_mbolie_characteristic"/></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--accordion-->
        </div>
      </div>
    </section> 

    <section class="row-hp-pd120 page-service">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1 class="tit_hp">스마트한 대화형 AI 서비스를 위한 모든 것이 한 자리에</h1>
            <h3 class="subtit_hp">챗봇 및 보이스봇과 같은 대화형 AI를 성공적으로 구축하고 관리하는데 필요한<br/>모든 기능을 하나의 플랫폼에서 통합적으로 제공합니다. </h3>
          </div>
        </div>
        <div class="row box_row pd-t50 align-items-center">
          <div class="col-md-6 box_left box_txt">
            <h5 class="box_tit">간단한 설정만으로 고성능 AI 에이전트 즉시 생성 및 배포</h5>
            <p class="box_subtxt">
              봇 에이전트를 직접 개발할 필요 없이 클릭 몇 번만으로 비즈니스 목적에 맞는 <br class="pcblock"/>
              맞춤형 챗봇 및 보이스봇을 즉시 생성할 수 있습니다.
            </p>
            <ul class="ul_box">
              <li>Google Dialogflow, Microsoft Luis, IBM Watson, AWS Lex, NCP Clova 등 고성능 NLU 엔진 원클릭 연동</li>
              <li>풍부한 메시지 템플릿 및 위젯 제공으로 별도의 챗봇 클라이언트 개발 없이 브랜드 스타일에 맞는 채팅 화면 구현 및 챗봇 배포</li>
            </ul>
          </div>
          <div class="col-md-6 box_right box_img">
            <img src="@/assets/image/img_ai_01.jpg"/>
          </div>
        </div>
        <div class="row box_row align-items-center">
          <div class="col-md-6 box_right box_txt order-md-2">
            <h5 class="box_tit">문자 뿐만 아니라 음성 통화도 자동화</h5>
            <p class="box_subtxt">
              콜센터로 들어오는 수많은 단순 문의 전화 상담 및 해피콜과 같이 정형화된 아웃바운드 전화 업무도 AI 기반의 콜봇으로 자동화합니다.
            </p>
            <ul class="ul_box">
              <li>별도의 개발 및 인프라 구축없이 간단한 설정만으로 콜 시스템과 즉시 연계</li>
              <li>최고 성능의 음성 인식 및 음성 합성 기술을 사용하여 사람과 같은 음성 지원</li>
              <li>필요한 경우 AI 에이전트에서 상담원으로 원활한 상담 전환</li>
            </ul>
          </div>
          <div class="col-md-6 box_left box_img order-md-1">
            <img src="@/assets/image/img_ai_02.jpg"/>
          </div>
        </div>
        <!---->
        <div class="row box_row align-items-center">
          <div class="col-md-6 box_left box_txt">
            <h5 class="box_tit">비주얼 빌더를 통한 편리한 대화 설계 및 학습 관리</h5>
            <p class="box_subtxt">
              대규모 서비스 및 음성봇과 같은 복잡한 대화 시나리오도 쉽게 설계하고 관리합니다.
            </p>
            <ul class="ul_box">
              <li>직관적인 GUI 기반의 시나리오 빌더를 통해 비전문가도 쉽게 대화 설계</li>
              <li>구조적이고 확장성 높은 상태 머신 빌더를 통해 대규모 서비스도 명시적으로 구현</li>
              <li>별도의 대화 플로우 관리를 통해 여러 팀이 동시에 작업 수행</li>
            </ul>
          </div>
          <div class="col-md-6 box_right box_img">
            <img src="@/assets/image/img_ai_03.jpg"/>
          </div>
        </div>
        <div class="row box_row align-items-center">
          <div class="col-md-6 box_right box_txt order-md-2">
            <h5 class="box_tit">NLU 성능 평가, 분석 및 자동 학습</h5>
            <p class="box_subtxt">
              NLU 성능 평가 및 딥러닝 기반의 자동 학습을 통해 기존에 사람이 수동으로 수행하던 반복적이고 부정확한 학습 업무를 자동화하고 학습 품질을 향상시킵니다.
            </p>
            <ul class="ul_box">
              <li>가상 에이전트 성능을 정량적인 성과지표로 확인하고 객관적 수치에 근거하여 개선 수행</li>
              <li>대화 이력을 기반으로 신뢰도가 낮은 문장 추출 및 재학습 문장 추천</li>
              <li>BERT 기반의 인텐트 추천 모델을 통해 신뢰도 높은 인텐트 자동 추천</li>
            </ul>
          </div>
          <div class="col-md-6 box_left box_img order-md-1">
            <img src="@/assets/image/img_ai_04.jpg"/>
          </div>
        </div>
        <div class="row box_row align-items-center">
          <div class="col-md-6 box_left box_txt">
            <h5 class="box_tit">다양한 채팅, 메신저, 음성 채널 연동</h5>
            <p class="box_subtxt">
              한 번의 빌드로 웹사이트, 모바일앱, 채팅 및 메신저 플랫폼, AI 스피커, 콜센터까지 사용자가 있는 곳 어디에나 봇을 배포할 수 있습니다.
            </p>
            <ul class="ul_box">
              <li>카카오톡, 페이스북, 왓츠앱, 슬랙, 라인, 텔레그램, 네이버톡, 라인 등 다양한 채팅, 메신저 채널 지원</li>
              <li>Google Assistant, Amazon Alexa, Microsoft Cortana, SKT NUGU 등 AI 스피커 지원</li>
              <li>MS 팀즈, 사내 메신저 등 기업 업무용 메신저 지원</li>
            </ul>
          </div>
          <div class="col-md-6 box_right box_img">
            <img src="@/assets/image/img_ai_05.jpg"/>
          </div>
        </div>
        <div class="row box_row align-items-center">
          <div class="col-md-6 box_right box_txt order-md-2">
            <h5 class="box_tit">VoC 데이터 분석 및 시각화</h5>
            <p class="box_subtxt">
              챗봇, 보이스봇, 컨택센터 등 다양한 채널에서 발생한 비정형 데이터를 한 곳에서 통합적으로 분석하여 데이터 기반 의사 결정을 지원합니다.
            </p>
            <ul class="ul_box">
              <li>비정형 데이터 안의 관계와 패턴 분석 결과를 시각화하여 데이터 인사이트 확보</li>
              <li>워드클라우드, 키워드별 사용 빈도 등 다양한 지표를 통해 사용자들의 관심 사항 파악</li>
              <li>시나리오 흐름 분석을 통해 사용자의 대화 패턴 분석</li>
            </ul>
          </div>
          <div class="col-md-6 box_left box_img order-md-1">
            <img src="@/assets/image/img_ai_06.jpg"/>
          </div>
        </div>
        <div class="row box_row align-items-center">
          <div class="col-md-6 box_left box_txt">
            <h5 class="box_tit">상담원과 연계한 채팅 상담</h5>
            <p class="box_subtxt">
              챗봇과 상담 중 상담원에게 연결하여 채팅 상담을 진행할 수 있습니다. 에이전트 어시스트를 통해 상담사의 상담 업무도 보조할 수 있습니다. 
            </p>
            <ul class="ul_box">
              <li>챗봇과 상담원 간 자연스러운 대화 연계</li>
              <li>다양한 상담 채널 관리 및 다중 고객 응대</li>
              <li>에이전트 어시스트를 통해 상담원이 고객 문의에 더 빠르고 정확하게 응답</li>
            </ul>
          </div>
          <div class="col-md-6 box_right box_img">
            <img src="@/assets/image/img_ai_07.jpg"/>
          </div>
        </div>
        <div class="row box_row align-items-center">
          <div class="col-md-6 box_right box_txt order-md-2">
            <h5 class="box_tit">FAQ 또는 수많은 문서에 있는 정보도 대화로 검색 </h5>
            <p class="box_subtxt">
              자주 묻는 질문, 정책, 제품 정보에 대한 탐색을 키워드 검색 방식이 아닌 자연어 인터페이스를 통해 정확하고 개인화된 답변을 제공합니다.
            </p>
            <ul class="ul_box">
              <li>NLU 모델을 기반으로 사용자의 의도를 파악하여 문서 탐색</li>
              <li>정확한 응답을 보장하기 위해 신뢰도에 따른 답변 제안</li>
              <li>관리자를 위한 FAQ 등록 및 파일 업로드 등 사용자 친화적인 관리 기능 제공</li>
            </ul>
          </div>
          <div class="col-md-6 box_left box_img order-md-1">
            <img src="@/assets/image/img_ai_08.jpg"/>
          </div>
        </div>
        <div class="row box_row border0 align-items-center">
          <div class="col-md-6 box_left box_txt">
            <h5 class="box_tit">확장성 및 편리한 시스템 연계</h5>
            <p class="box_subtxt">
              다양한 시스템과의 연계 및 확장이 용이합니다.
            </p>
            <ul class="ul_box">
              <li>오픈 API와 웹훅 지원으로 레거시 시스템과 연계하여 더 많은 워크플로우 자동화</li>
              <li>지도, 날씨, 주식 등 다양한 외부 서비스와 API 연계 가능</li>
              <li>최신 AI/ML 기술과 연계하여 개인화 서비스 등 다양한 서비스 구현 가능</li>
            </ul>
          </div>
          <div class="col-md-6 box_right box_img">
            <img src="@/assets/image/img_ai_09.jpg"/>
          </div>
        </div>
        <!--btn-->
        <div class="container">
          <div class="row">
            <div class="col-md-12 txt_center mr-t30">
              <a class="btn_purple" href="https://www.bespinglobal.com/contact/" target="_blank" title="문의하기 이동">HelpNow Conversational AI 문의하기</a>
            </div>
          </div>
        </div>
      <!--btn-->
      </div>
    </section>

    <section class="row-hp-pd page-faq">
      <div class="container">
        <div class="row mr-b50">
          <div class="col-md-12">
            <h1 class="tit_hp">FAQ</h1>
          </div>
        </div>
        <div class="row">
          <!--accordion-->
          <div class="col-md-12">
            <div class="accordion panel" id="accordionPanelsStayOpenExample">
              <div class="accordion-item" v-for="(item, index) in accordionFaq" :key="index">
                <h2 class="accordion-header panel-heading">
                  <button class="accordion-button" :class="{'collapsed' : !item.show}" type="button" @click="item.show = !item.show">{{item.title}} </button>
                </h2>
                <div class="accordion-collapse collapse" :class="{ 'show' : item.show }">
                  <div class="accordion-body">
                    <p>
                      {{item.content}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--accordion-->
        </div>
      </div>
    </section>

    <section class="row-hp-pd120 page-value">
      <div class="container">
        <div class="row mr-b120">
          <div class="col-md-12">
            <h1 class="tit_hp">HelpNow AI와 함께 새로운 경험을 제공하고 비즈니스 가치를 높이세요</h1>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="box-value">
              <img src="@/assets/image/icn_ai_01.png">
              <h3><span class="txt_purple">24시간 무중단 </span><br class="pcblock"/>
              고객 지원 서비스</h3>
              <p class="pd20">
                잠들지 않는 스마트 에이전트를 통해<br class="pcblock1200"/>
                전화, 문자, SNS 등 다양한 채널에서<br class="pcblock1200"/>
                연중무휴 24시간 고객에게 서비스를 제공하세요.
              </p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="box-value">
              <img src="@/assets/image/icn_ai_02.png">
              <h3><span class="txt_purple">HR 봇</span>으로 <br class="pcblock"/>
              직원 관계 강화</h3>
              <p class="pd20">
                대화형 AI와 지식 기반을 통해 <br class="pcblock1200"/>
                모든 직원 질문에 신속하고 정확한 답변을 제공하고 <br class="pcblock1200"/>
                복리후생, 휴가 등의 업무를 처리합니다.
              </p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="box-value">
              <img src="@/assets/image/icn_ai_03.png">
              <h3>학사행정 봇으로 <br class="pcblock"/>
              <span class="txt_purple">학생 지원 자동화</span></h3>
              <p class="pd20">
                입학 문의, 학사 과정 안내, <br class="pcblock1200"/>
                학사 행정 처리와 같은 학생 지원 서비스를 <br class="pcblock1200"/>
                비대면으로 자동화 할 수 있습니다.
              </p>
            </div>
          </div>
        </div>
        <div class="row mr-t100">
          <div class="col-md-4">
            <div class="box-value">
              <img src="@/assets/image/icn_ai_04.png">
              <h3><span class="txt_purple">개인화 서비스</span>를 통한 <br class="pcblock"/>
              판매 촉진</h3>
              <p class="pd20">
                구매내역, 장바구니 등 고객 정보를 바탕으로 <br class="pcblock1200"/>
                고객 맞춤형 정보를 제공하여<br class="pcblock1200"/>
                판매를 촉진할 수 있습니다.
              </p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="box-value">
              <img src="@/assets/image/icn_ai_05.png">
              <h3>다국어 봇으로 <span class="txt_purple">전세계 <br class="pcblock"/>
              고객・협력사 지원</span></h3>
              <p class="pd20">
                고객의 언어를 구사하는 직원이 없더라도 <br class="pcblock1200"/>
                사용자의 언어로 실시간으로 소통하여 <br class="pcblock1200"/>
                즉각적인 지원을 할 수 있습니다.
              </p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="box-value">
              <img src="@/assets/image/icn_ai_06.png">
              <h3><span class="txt_purple">점주용 AI 봇</span>을 통한 <br class="pcblock"/>
              업무 효율화</h3>
              <p class="pd20">
                스마트 에이전트를 통해 영업점, 대리점, 가맹점의 <br class="pcblock1200"/>
                주문, 교환, 반품, A/S 상담 접수를 지원하여 <br class="pcblock1200"/>
                상담 대기 시간은 감소하고 <br class="pcblock1200"/>
                영업 담당자의 업무 효율성은 향상됩니다.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="row-hp-btn-bg pd_b50">
      <div class="container">
        <div class="row">
          <div class="col-md-12 txt_center">
            <h1>With HelpNow AI</h1>
            <h3>HelpNow AI와 함께 새로운 변화를 경험해 보세요.</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 txt_center">
            <a href="https://www.bespinglobal.com/contact/" target="_blank" title="문의하기 이동" class="btn_white">문의하기</a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'ConversationalAi',
    components: {
      
    },
    data() {
      return {   
        onCurrAccordion: '', 
        onCurrAccordionImage: '', 
        accordion: [
          {
            title: '강력한 NLU 엔진으로 똑똑한 봇 구현', 
            content: 'Google Dialogflow, AWS Lex, Naver Clova, Kakao i 등 최고 성능의 NLU를 통합하여 사용자의 의도를 정확하게 파악하여 상호작용', 
            imageUrl: require("@/assets/image/img_ai_ar_01.jpg"), 
          },
          {
            title: '쉽고 빠른 개발과 편리한 운영 관리', 
            content: '사용자 친화적인 그래픽 환경에서 누구나 쉽고 빠르게 대화를 설계하고 다양한 운영 편의 기능을 통해 편리하게 운영', 
            imageUrl: require("@/assets/image/img_ai_ar_02.jpg"), 
          },
          {
            title: '딥러닝 기반의 NLU 자동 학습으로 운영 효율화', 
            content: '지속적인 성능 향상을 위해 많은 인력을 투입하여 수행하던 NLU 트레이닝 및 학습 모델 튜닝 작업을 90% 이상 자동화', 
            imageUrl: require("@/assets/image/img_ai_ar_03.jpg"), 
          },
          {
            title: '인지검색을 통해 FAQ 또는 문서에 있는 정보도 질문으로 탐색', 
            content: '자주하는 질문 또는 기술 문서와 같이 기존에 키워드로 검색하던 지식관리정보도 사람에게 문의하듯 자연스러운 대화로 질의하고 탐색', 
            imageUrl: require("@/assets/image/img_ai_ar_04.jpg"), 
          },
        ], 
        accordionFaq: [
          {
            title: '강력한 NLU 엔진으로 똑똑한 봇 구현', 
            content: 'Google Dialogflow, AWS Lex, Naver Clova, Kakao i 등 최고 성능의 NLU를 통합하여 사용자의 의도를 정확하게 파악하여 상호작용', 
            show: false, 
          },
          {
            title: '쉽고 빠른 개발과 편리한 운영 관리', 
            content: '사용자 친화적인 그래픽 환경에서 누구나 쉽고 빠르게 대화를 설계하고 다양한 운영 편의 기능을 통해 편리하게 운영', 
            show: false, 
          },
          {
            title: '딥러닝 기반의 NLU 자동 학습으로 운영 효율화', 
            content: '지속적인 성능 향상을 위해 많은 인력을 투입하여 수행하던 NLU 트레이닝 및 학습 모델 튜닝 작업을 90% 이상 자동화', 
            show: false, 
          },
          {
            title: '인지검색을 통해 FAQ 또는 문서에 있는 정보도 질문으로 탐색', 
            content: '자주하는 질문 또는 기술 문서와 같이 기존에 키워드로 검색하던 지식관리정보도 사람에게 문의하듯 자연스러운 대화로 질의하고 탐색', 
            show: false, 
          },
        ]
      }
    },
    computed: {},
    watch: {},
    created(){},
    mounted(){
      this.onActiveAccordion(this.accordion[0].imageUrl, 0); 
    },
    beforeDestroy() {},
    methods: {
      onChangeRoute(routeName, event) {
        event.preventDefault();
        this.$router.push({name: routeName})

        window.scrollTo(0, 0); 
      }, 

      onActiveAccordion(url, index) {
        this.onCurrAccordion = index; 
        this.onCurrAccordionImage = url; 
      }
    }
  }
</script>

<style lang="scss" scoped>
  
</style>


// WEBPACK FOOTER //
// src/components/ConversationalAi.vue